import { locales } from '../../../constants/constants.js';
import { wcpmLookupTable } from '../values/scales.js'; // TODO: populate this with data from Billy
import { seasons } from './getScaledBenchmarkCutlines';
import getSeason from './getSeason';


// TODO
// https://amiralearning.atlassian.net/browse/AE-1276
// 1. Deprecate this constant
// 2. Consolidate with benchmark types, move to /values (or global constants)
// 3. Entirely deprecate constant, populate scaleTypes via call to backend
// 4. Reconsider whether this lookup table belongs in the fronend at all
export const scaleType = {
  WCPM: 'WCPM',
  equatedWCPM: 'equatedWCPM',
  Lexile: 'Lexile',
  DRA: 'DRA',
  Guided_Reading_Level: 'Guided_Reading_Level',
  ARM: 'ARM'
}

// TODO deprecate scaleScore
export function scaleScore(score, type, activity,locale) {
  if(scaleType[type]) {
    let metrics = getRolledUpActivityMetrics(activity);
    if(!metrics || Object.keys(metrics).length === 0) return null;
    if(type !== "WCPM" && type !== "equatedWCPM"){
      //###Leave in for debug console.log(activity,metrics);
      let CLSScore = calculateCLS(metrics.areaScore,score,metrics.wordsRead,metrics.numberOfErrors,activity.student.grade,activity.createdAt,locale);
      //###Leave in for debug console.log(activity.activityId,CLSScore)
      let concordanceScore = doConcordance(CLSScore,locale);
      return concordanceScore[type];
    }else{
      // For WCPM/equatedWCPM, use the passed score parameter or fallback to activity scores
      const wcpmScore = activity.scores.wcpmScore || activity.scores.equatedWCPM;
      return Math.round(wcpmScore);
    }

  } else {
    console.log('error, unknown scale type: ', type);
    return null;
  }
}

export function scaleORF(score, sourceType, translateType) {
  if(scaleType[sourceType] && scaleType[translateType]) {
    let roundedScore = Math.round(score);
    let concordanceScore = wcpmLookupTable.find(s => s[sourceType] === roundedScore);
    return concordanceScore && concordanceScore[translateType] || 0;
  } else {
    console.log('error, unknown scale type: ', sourceType,translateType);
    return null;
  }
}

export function calculateCLS(areaScore,adjustedWCPM,wordsRead,numberOfErrors,studentGrade,activityDate,locale){
  //### May need to leave this at 5th in case we don't have 6th grade concordance
  if(studentGrade > 5) studentGrade = 5;
  let baseScore = calculateBaseScore(wordsRead,numberOfErrors,studentGrade,activityDate);
  let areaFromWCPM = wcpmToArea(adjustedWCPM,studentGrade,activityDate,locale);
  //###Leave in for debug console.log("CLS:",activityDate)
  //###Leave in for debug console.log("CLS",areaScore,areaFromWCPM,baseScore);
  let CLS = 5.2;
  if(wordsRead-numberOfErrors>14){
    CLS = Math.max(5.3,((3*areaScore)+areaFromWCPM+baseScore)/5);
  }

  let minmax = getBaseMinMax(studentGrade,activityDate);
  if(CLS > minmax.max) CLS = minmax.max;

  return CLS;
}

export function calculateBaseScore(wordsRead,numberOfErrors,grade,date){
  //###Leave in for debug console.log("********************")
  //###Leave in for debug console.log(wordsRead,numberOfErrors,grade);
  let coreBaseScore = (((((wordsRead/200)*100)+((1-(1.2*(numberOfErrors/wordsRead)))*100)))/17)-1;

  //###Leave in for debug console.log("CBS",coreBaseScore);
  //Adjust for short forms
  let sfAdjustment = 0;
  if((wordsRead<60)&&(wordsRead-numberOfErrors>20)){
    sfAdjustment = 0.7;
  }else{
    if((coreBaseScore<6.5) && (wordsRead-numberOfErrors>20)){
      sfAdjustment = 0.9;
    }else{
      if((coreBaseScore>9)&&(numberOfErrors>20)){
        sfAdjustment = -0.8;
      }else{
        if(coreBaseScore>9){
          sfAdjustment = -0.9;
        }
      }
    }
  }
  //###Leave in for debug console.log("SFA",sfAdjustment);

  //Adjust for errors
  let errAdjustment = 0;
  //###Leave in for debug console.log("RATIO",numberOfErrors/wordsRead);
  if(numberOfErrors/wordsRead>0.24){
    errAdjustment = -0.5;
  }else{
    if(numberOfErrors/wordsRead>0.16){
      errAdjustment = -0.3;
    }else{
      if(numberOfErrors/wordsRead<0.05){
        errAdjustment = 0.3;
      }
    }
  }


  //Adjust the core Base Score
  //###Leave in for debug //###Leave in for debug console.log("ERRA",errAdjustment);
  let baseScore = coreBaseScore + errAdjustment + sfAdjustment;
  //###Leave in for debug console.log("BS1",baseScore);
  //Now adjust for level
  if(baseScore>8.5){
    baseScore -= 0.6;
  }else{
    if(baseScore>7){
      baseScore -= 0.35;
    }else{
      baseScore -= 0.2;
    }
  }
  //###Leave in for debug console.log("BS",baseScore)
  //Apply the min and max
  //###Leave in for debug console.log("G",grade);
  let minmax = getBaseMinMax(grade,date);
  //###Leave in for debug console.log("BS:",date)
  //###Leave in for debug console.log("MM",minmax);
  //###Leave in for debug console.log(minmax.max,baseScore,minmax.min);
  baseScore = Math.min(minmax.max,Math.max(baseScore,minmax.min));

  return baseScore;
}

function getBaseMinMax(grade,date){
  let season = getSeason(date);
  let seasonMinMax = baseScoreMinMax.filter((row)=>{
    return row.season == season;
  });
  let baseMinMax = seasonMinMax.filter((row)=>{
    return row.grade == grade;
  });

  return baseMinMax[0];
}

function wcpmToArea(wcpmScore,grade,date,locale){
  const isValueLargerThanScore = (element) => element[0] > wcpmScore;
  let tableToUse = locale === locales.ES_MX ? spanishWcpmToAreaLookup : wcpmToAreaLookup;
  let index = tableToUse.findIndex(isValueLargerThanScore) - 1;

  if(index < 0) index = tableToUse.length - 1;

  let areaLookup = tableToUse[index][1];
  //###Leave in for debug console.log("WtoALookup",areaLookup)
  if(areaLookup > 6.3) areaLookup -= 0.7;
  //###Leave in for debug console.log("AdjWtoA",areaLookup)
  let minmax = getBaseMinMax(grade,date);
  let area = Math.min(minmax.max,Math.max(areaLookup,minmax.min));
  //###Leave in for debug console.log("finalWtoA",area);
  return(area);
}

export function doConcordance(clsScore,locale){
  const isValueLargerThanScore = (element) => element.AREA > clsScore;
  let tableToUse = locale === locales.ES_MX ? spanishAreaConcordance : areaConcordance;
  let index = tableToUse.findIndex(isValueLargerThanScore) - 1;

  if(index < 0) index = tableToUse.length - 1;
  return(tableToUse[index]);
}

export function getRolledUpActivityMetrics(activity){
  let baseActivityMetrics = getActivityMetrics(activity);
  if(activity.children){
    activity.children.map((child)=>{
      if(child.type == 'readingComprehension'){
        let childMetrics = getActivityMetrics(child);
        baseActivityMetrics.wordsRead += childMetrics.wordsRead;
        baseActivityMetrics.numberOfErrors += childMetrics.numberOfErrors;
      }
    });
  }

  return baseActivityMetrics;
}

export function getActivityMetrics(activity){
  if(!activity.errors){
    return {};
  }

  let wordsRead = activity.errors.reduce((wordsSoFar,phraseErrors)=>{
    return phraseErrors.length + wordsSoFar;
  },0);

  let numberOfErrors = activity.errors.reduce((errorsSoFar,phraseErrors)=>{
    let errors = phraseErrors.reduce((accum,error)=>{
      return accum + (error ? 1 : 0);
    },0);
    return errorsSoFar + errors;
  },0);

  let score = activity.scores && activity.scores.areaScore;
  return {wordsRead: wordsRead, numberOfErrors: numberOfErrors, areaScore: score};
}

//###Need real values for 4 and 5
const baseScoreMinMax = [
  {grade: 0,season: "fall",min: 5.2,max: 999},
  {grade: 0,season: "winter",min: 5.2,max: 999},
  {grade: 0,season: "spring",min: 5.2,max: 999},
  {grade: 1,season: "fall",min: 5.2,max: 999},
  {grade: 1,season: "winter",min: 5.2,max: 999},
  {grade: 1,season: "spring",min: 5.2,max: 999},
  {grade: 2,season: "fall",min: 5.8,max: 999},
  {grade: 2,season: "winter",min: 6,max: 999},
  {grade: 2,season: "spring",min: 6.3,max: 999},
  {grade: 3,season: "fall",min: 6.4,max: 999},
  {grade: 3,season: "winter",min: 6.6,max: 999},
  {grade: 3,season: "spring",min: 6.9,max: 999},
  {grade: 4,season: "fall",min: 6.9,max: 999},
  {grade: 4,season: "winter",min: 7.1,max: 999},
  {grade: 4,season: "spring",min: 7.4,max: 999},
  {grade: 5,season: "fall",min: 7.4,max: 999},
  {grade: 5,season: "winter",min: 7.6,max: 999},
  {grade: 5,season: "spring",min: 7.9,max: 999}
];

const wcpmToAreaLookup = [
  [0,4.1],
  [1,4.2],
  [2,4.4],
  [3,4.6],
  [4,4.8],
  [5,5],
  [6,5.25],
  [7,5.317],
  [8,5.4],
  [9,5.451],
  [10,5.518],
  [11,5.585],
  [12,5.652],
  [13,5.719],
  [14,5.8],
  [15,5.92],
  [16,5.986],
  [17,6.041],
  [18,6.096],
  [19,6.151],
  [20,6.25],
  [21,6.3],
  [22,6.4],
  [23,6.45],
  [24,6.5],
  [25,6.55],
  [26,6.6],
  [27,6.76],
  [28,6.79],
  [29,6.81],
  [30,6.83],
  [31,6.9],
  [32,6.95],
  [33,7],
  [34,7.05],
  [35,7.1],
  [36,7.15],
  [37,7.2],
  [38,7.25],
  [39,7.29375],
  [40,7.3375],
  [41,7.4],
  [42,7.45],
  [43,7.46875],
  [44,7.5125],
  [45,7.55625],
  [46,7.56],
  [47,7.58],
  [48,7.6],
  [49,7.7],
  [50,7.75],
  [51,7.8],
  [52,7.82],
  [53,7.84],
  [54,7.85],
  [55,7.88],
  [56,7.9],
  [57,7.93],
  [58,7.96],
  [59,7.99],
  [60,8.01],
  [61,8.03],
  [62,8.04],
  [63,8.1],
  [64,8.15],
  [65,8.2],
  [66,8.23],
  [67,8.25],
  [68,8.29],
  [69,8.33],
  [70,8.37],
  [71,8.4],
  [72,8.45],
  [73,8.49],
  [74,8.53],
  [75,8.57],
  [76,8.6],
  [77,8.64],
  [78,8.68],
  [79,8.72],
  [80,8.76],
  [81,8.8],
  [82,8.84],
  [83,8.86],
  [84,8.88],
  [85,8.9],
  [86,8.94],
  [87,8.98],
  [88,9.02],
  [89,9.06],
  [90,9.1],
  [91,9.14],
  [92,9.18],
  [93,9.22],
  [94,9.25],
  [95,9.3],
  [96,9.35],
  [97,9.4],
  [98,9.45],
  [99,9.5],
  [100,9.55],
  [101,9.6],
  [102,9.62],
  [103,9.64],
  [104,9.66],
  [105,9.68],
  [106,9.7],
  [107,9.72],
  [108,9.74],
  [109,9.76],
  [110,9.78],
  [111,9.8],
  [112,9.83],
  [113,9.86],
  [114,9.89],
  [115,9.92],
  [116,9.95],
  [117,9.98],
  [118,10],
  [119,10.02],
  [120,10.05],
  [121,10.07],
  [122,10.1],
  [123,10.15],
  [124,10.25],
  [125,10.3],
  [126,10.4],
  [127,10.5],
  [128,10.6],
  [129,10.65],
  [130,10.7],
  [131,10.75],
  [132,10.8],
  [133,10.83],
  [134,10.86],
  [135,10.89],
  [136,10.92],
  [137,10.95],
  [138,11],
  [139,11.05],
  [140,11.1],
  [141,11.15],
  [142,11.2],
  [143,11.25],
  [144,11.3],
  [145,11.4],
  [146,11.5],
  [147,11.6],
  [148,11.7],
  [149,11.75],
  [150,11.8],
  [151,11.9],
  [152,11.95],
  [153,12],
  [154,12.1],
  [155,12.11],
  [156,12.12],
  [157,12.13],
  [158,12.14],
  [159,12.15],
  [160,12.16],
  [161,12.17],
  [162,12.18],
  [163,12.19],
  [164,12.2],
  [165,12.21],
  [166,12.22],
  [167,12.23],
  [168,12.24],
  [169,12.25],
  [170,12.26],
  [171,12.27],
  [172,12.28],
  [173,12.29],
  [174,12.3],
  [175,12.31],
  [176,12.32],
  [177,12.33],
  [178,12.34],
  [179,12.35],
  [180,12.36],
  [181,12.37],
  [182,12.38],
  [183,12.39],
  [184,12.4],
  [185,12.41],
  [186,12.42],
  [187,12.43],
  [188,12.44],
  [189,12.45],
  [190,12.46],
  [191,12.47],
  [192,12.48],
  [193,12.49],
  [194,12.5],
  [195,12.51],
  [196,12.52],
  [197,12.53],
  [198,12.54],
  [199,12.55],
  [200,12.56],
  [201,12.57],
  [202,12.58],
  [203,12.59],
  [204,12.6],
  [205,12.61],
  [206,12.62],
  [207,12.63],
  [208,12.64],
  [209,12.65],
  [210,12.66],
  [211,12.67],
  [212,12.68],
  [213,12.69],
  [214,12.7],
  [215,12.71],
  [216,12.72],
  [217,12.73],
  [218,12.74],
  [219,12.75],
  [220,12.76],
  [221,12.77],
  [222,12.78],
  [223,12.79],
  [224,12.8],
  [225,12.81],
  [226,12.82],
  [227,12.83],
  [228,12.84],
  [229,12.85],
  [230,12.86],
  [231,12.87],
  [232,12.88],
  [233,12.89],
  [234,12.9],
  [235,12.91],
  [236,12.92],
  [237,12.93],
  [238,12.94],
  [239,12.95],
  [240,12.96],
  [241,12.97],
  [242,12.98],
  [243,12.99],
  [244,13],
  [245,13.01],
  [246,13.02],
  [247,13.03],
  [248,13.04],
  [249,13.05],
  [250,13.06],
  [251,13.07],
  [252,13.08],
  [253,13.09],
  [254,13.1],
  [255,13.11],
  [256,13.12],
  [257,13.13],
  [258,13.14],
  [259,13.15],
  [260,13.16],
  [261,13.17],
  [262,13.18],
  [263,13.19],
  [264,13.2],
  [265,13.21],
  [266,13.22],
  [267,13.23],
  [268,13.24],
  [269,13.25],
  [270,13.26],
  [271,13.27],
  [272,13.28],
  [273,13.29],
  [274,13.3],
  [275,13.31],
  [276,13.32],
  [277,13.33],
  [278,13.34],
  [279,13.35],
  [280,13.36],
  [281,13.37],
  [282,13.38],
  [283,13.39],
  [284,13.4],
  [285,13.41],
  [286,13.42],
  [287,13.43],
  [288,13.44],
  [289,13.45],
  [290,13.46],
  [291,13.47],
  [292,13.48],
  [293,13.49],
  [294,13.5],
  [295,13.5],
  [296,13.5],
  [297,13.5],
  [298,13.5],
  [299,13.5],
  [300,13.5]
];

const spanishWcpmToAreaLookup = [
  [0, 3.8],
  [1, 4.5],
  [2, 4.8],
  [3, 5.1],
  [4, 5.2],
  [5, 5.4],
  [6, 5.6],
  [7, 5.7],
  [8, 5.8],
  [9, 5.9],
  [10, 6],
  [11, 6.1],
  [12, 6.2],
  [13, 6.3],
  [14, 6.4],
  [15, 6.5],
  [16, 6.6],
  [17, 6.7],
  [18, 6.8],
  [19, 6.8],
  [20, 6.9],
  [21, 7],
  [22, 7],
  [23, 7.1],
  [24, 7.2],
  [25, 7.2],
  [26, 7.3],
  [27, 7.3],
  [28, 7.4],
  [29, 7.5],
  [30, 7.5],
  [31, 7.6],
  [32, 7.6],
  [33, 7.7],
  [34, 7.7],
  [35, 7.8],
  [36, 7.8],
  [37, 7.9],
  [38, 7.9],
  [39, 8],
  [40, 8],
  [41, 8.1],
  [42, 8.1],
  [43, 8.1],
  [44, 8.2],
  [45, 8.2],
  [46, 8.3],
  [47, 8.3],
  [48, 8.4],
  [49, 8.4],
  [50, 8.4],
  [51, 8.5],
  [52, 8.5],
  [53, 8.6],
  [54, 8.6],
  [55, 8.6],
  [56, 8.7],
  [57, 8.7],
  [58, 8.7],
  [59, 8.8],
  [60, 8.8],
  [61, 8.8],
  [62, 8.9],
  [63, 8.9],
  [64, 8.9],
  [65, 9],
  [66, 9],
  [67, 9],
  [68, 9.1],
  [69, 9.1],
  [70, 9.1],
  [71, 9.2],
  [72, 9.2],
  [73, 9.2],
  [74, 9.2],
  [75, 9.3],
  [76, 9.3],
  [77, 9.3],
  [78, 9.4],
  [79, 9.4],
  [80, 9.4],
  [81, 9.4],
  [82, 9.5],
  [83, 9.5],
  [84, 9.5],
  [85, 9.6],
  [86, 9.6],
  [87, 9.6],
  [88, 9.6],
  [89, 9.7],
  [90, 9.7],
  [91, 9.7],
  [92, 9.7],
  [93, 9.8],
  [94, 9.8],
  [95, 9.8],
  [96, 9.8],
  [97, 9.9],
  [98, 9.9],
  [99, 9.9],
  [100, 9.9],
  [101, 10],
  [102, 10],
  [103, 10],
  [104, 10],
  [105, 10],
  [106, 10.1],
  [107, 10.1],
  [108, 10.1],
  [109, 10.1],
  [110, 10.2],
  [111, 10.2],
  [112, 10.2],
  [113, 10.2],
  [114, 10.2],
  [115, 10.3],
  [116, 10.3],
  [117, 10.3],
  [118, 10.3],
  [119, 10.3],
  [120, 10.4],
  [121, 10.4],
  [122, 10.4],
  [123, 10.4],
  [124, 10.4],
  [125, 10.5],
  [126, 10.5],
  [127, 10.5],
  [128, 10.5],
  [129, 10.5],
  [130, 10.6],
  [131, 10.6],
  [132, 10.6],
  [133, 10.6],
  [134, 10.6],
  [135, 10.6],
  [136, 10.7],
  [137, 10.7],
  [138, 10.7],
  [139, 10.7],
  [140, 10.7],
  [141, 10.7],
  [142, 10.8],
  [143, 10.8],
  [144, 10.8],
  [145, 10.8],
  [146, 10.8],
  [147, 10.8],
  [148, 10.9],
  [149, 10.9],
  [150, 10.9],
  [151, 10.9],
  [152, 10.9],
  [153, 10.9],
  [154, 11],
  [155, 11],
  [156, 11],
  [157, 11],
  [158, 11],
  [159, 11],
  [160, 11.1],
  [161, 11.1],
  [162, 11.1],
  [163, 11.1],
  [164, 11.1],
  [165, 11.1],
  [166, 11.1],
  [167, 11.2],
  [168, 11.2],
  [169, 11.2],
  [170, 11.2],
  [171, 11.2],
  [172, 11.2],
  [173, 11.2],
  [174, 11.3],
  [175, 11.3],
  [176, 11.3],
  [177, 11.3],
  [178, 11.3],
  [179, 11.3],
  [180, 11.3],
  [181, 11.4],
  [182, 11.4],
  [183, 11.4],
  [184, 11.4],
  [185, 11.4],
  [186, 11.4],
  [187, 11.4],
  [188, 11.4],
  [189, 11.5],
  [190, 11.5],
  [191, 11.5],
  [192, 11.5],
  [193, 11.5],
  [194, 11.5],
  [195, 11.5],
  [196, 11.5],
  [197, 11.6],
  [198, 11.6],
  [199, 11.6],
  [200, 11.6],
  [201, 11.6],
  [202, 11.6],
  [203, 11.6],
  [204, 11.6],
  [205, 11.7],
  [206, 11.7],
  [207, 11.7],
  [208, 11.7],
  [209, 11.7],
  [210, 11.7],
  [211, 11.7],
  [212, 11.7],
  [213, 11.7],
  [214, 11.8],
  [215, 11.8],
  [216, 11.8],
  [217, 11.8],
  [218, 11.8],
  [219, 11.8],
  [220, 11.8],
  [221, 11.8],
  [222, 11.8],
  [223, 11.9],
  [224, 11.9],
  [225, 11.9],
  [226, 11.9],
  [227, 11.9],
  [228, 11.9],
  [229, 11.9],
  [230, 11.9],
  [231, 11.9],
  [232, 12],
  [233, 12],
  [234, 12],
  [235, 12],
  [236, 12],
  [237, 12],
  [238, 12],
  [239, 12],
  [240, 12],
  [241, 12],
  [242, 12.1],
  [243, 12.1],
  [244, 12.1],
  [245, 12.1],
  [246, 12.1],
  [247, 12.1],
  [248, 12.1],
  [249, 12.1],
  [250, 12.1],
  [251, 12.1],
  [252, 12.1],
  [253, 12.2],
  [254, 12.2],
  [255, 12.2],
  [256, 12.2],
  [257, 12.2],
  [258, 12.2],
  [259, 12.2],
  [260, 12.2],
  [261, 12.2],
  [262, 12.2],
  [263, 12.2],
  [264, 12.2],
  [265, 12.3],
  [266, 12.3],
  [267, 12.3],
  [268, 12.3],
  [269, 12.3],
  [270, 12.3],
  [271, 12.3],
  [272, 12.3],
  [273, 12.3],
  [274, 12.3],
  [275, 12.3],
  [276, 12.3],
  [277, 12.4],
  [278, 12.4],
  [279, 12.4],
  [280, 12.4],
  [281, 12.4],
  [282, 12.4],
  [283, 12.4],
  [284, 12.4],
  [285, 12.4],
  [286, 12.4],
  [287, 12.4],
  [288, 12.4],
  [289, 12.4],
  [290, 12.5],
  [291, 12.5],
  [292, 12.5],
  [293, 12.5],
  [294, 12.5],
  [295, 12.5],
  [296, 12.5],
  [297, 12.5],
  [298, 12.5],
  [299, 12.5],
  [300, 12.5]
];

const areaConcordance = [
  {WCPM: 0, AREA: 4.1, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 1, AREA: 4.2, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 2, AREA: 4.4, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 3, AREA: 4.6, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 4, AREA: 4.8, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 5, AREA: 5, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 6, AREA: 5.25, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 7, AREA: 5.317, Guided_Reading_Level: "A", Lexile: -400, DRA: 1},
  {WCPM: 8, AREA: 5.4, Guided_Reading_Level: "B", Lexile: -365, DRA: 2},
  {WCPM: 9, AREA: 5.451, Guided_Reading_Level: "B", Lexile: -350, DRA: 2},
  {WCPM: 10, AREA: 5.518, Guided_Reading_Level: "B", Lexile: -325, DRA: 2},
  {WCPM: 11, AREA: 5.585, Guided_Reading_Level: "B", Lexile: -300, DRA: 2},
  {WCPM: 12, AREA: 5.652, Guided_Reading_Level: "B", Lexile: -280, DRA: 2},
  {WCPM: 13, AREA: 5.719, Guided_Reading_Level: "B", Lexile: -255, DRA: 2},
  {WCPM: 14, AREA: 5.8, Guided_Reading_Level: "C", Lexile: -225, DRA: 3},
  {WCPM: 15, AREA: 5.92, Guided_Reading_Level: "C", Lexile: -185, DRA: 3},
  {WCPM: 16, AREA: 5.986, Guided_Reading_Level: "C", Lexile: -165, DRA: 3},
  {WCPM: 17, AREA: 6.041, Guided_Reading_Level: "C", Lexile: -145, DRA: 3},
  {WCPM: 18, AREA: 6.096, Guided_Reading_Level: "D", Lexile: -130, DRA: 4},
  {WCPM: 19, AREA: 6.151, Guided_Reading_Level: "D", Lexile: -110, DRA: 4},
  {WCPM: 20, AREA: 6.25, Guided_Reading_Level: "D", Lexile: -80, DRA: 4},
  {WCPM: 21, AREA: 6.3, Guided_Reading_Level: "D", Lexile: -60, DRA: 4},
  {WCPM: 22, AREA: 6.4, Guided_Reading_Level: "E", Lexile: -30, DRA: 6},
  {WCPM: 23, AREA: 6.45, Guided_Reading_Level: "E", Lexile: -15, DRA: 6},
  {WCPM: 24, AREA: 6.5, Guided_Reading_Level: "E", Lexile: 0, DRA: 8},
  {WCPM: 25, AREA: 6.55, Guided_Reading_Level: "E", Lexile: 15, DRA: 8},
  {WCPM: 26, AREA: 6.6, Guided_Reading_Level: "F", Lexile: 30, DRA: 10},
  {WCPM: 27, AREA: 6.76, Guided_Reading_Level: "F", Lexile: 80, DRA: 10},
  {WCPM: 28, AREA: 6.79, Guided_Reading_Level: "F", Lexile: 90, DRA: 10},
  {WCPM: 29, AREA: 6.81, Guided_Reading_Level: "G ", Lexile: 95, DRA: 12},
  {WCPM: 30, AREA: 6.83, Guided_Reading_Level: "G ", Lexile: 100, DRA: 12},
  {WCPM: 31, AREA: 6.9, Guided_Reading_Level: "G ", Lexile: 120, DRA: 12},
  {WCPM: 32, AREA: 6.95, Guided_Reading_Level: "H", Lexile: 135, DRA: 14},
  {WCPM: 33, AREA: 7, Guided_Reading_Level: "H", Lexile: 150, DRA: 14},
  {WCPM: 34, AREA: 7.05, Guided_Reading_Level: "H", Lexile: 165, DRA: 14},
  {WCPM: 35, AREA: 7.1, Guided_Reading_Level: "I", Lexile: 180, DRA: 16},
  {WCPM: 36, AREA: 7.15, Guided_Reading_Level: "I", Lexile: 195, DRA: 16},
  {WCPM: 37, AREA: 7.2, Guided_Reading_Level: "I", Lexile: 205, DRA: 16},
  {WCPM: 38, AREA: 7.25, Guided_Reading_Level: "J", Lexile: 220, DRA: 18},
  {WCPM: 39, AREA: 7.29375, Guided_Reading_Level: "J", Lexile: 235, DRA: 18},
  {WCPM: 40, AREA: 7.3375, Guided_Reading_Level: "J", Lexile: 245, DRA: 18},
  {WCPM: 41, AREA: 7.4, Guided_Reading_Level: "K", Lexile: 260, DRA: 20},
  {WCPM: 42, AREA: 7.45, Guided_Reading_Level: "K", Lexile: 275, DRA: 20},
  {WCPM: 43, AREA: 7.46875, Guided_Reading_Level: "K", Lexile: 280, DRA: 20},
  {WCPM: 44, AREA: 7.5125, Guided_Reading_Level: "K", Lexile: 290, DRA: 20},
  {WCPM: 45, AREA: 7.55625, Guided_Reading_Level: "K", Lexile: 305, DRA: 20},
  {WCPM: 46, AREA: 7.56, Guided_Reading_Level: "K", Lexile: 305, DRA: 20},
  {WCPM: 47, AREA: 7.58, Guided_Reading_Level: "K", Lexile: 310, DRA: 20},
  {WCPM: 48, AREA: 7.6, Guided_Reading_Level: "K", Lexile: 315, DRA: 20},
  {WCPM: 49, AREA: 7.7, Guided_Reading_Level: "K", Lexile: 340, DRA: 20},
  {WCPM: 50, AREA: 7.75, Guided_Reading_Level: "K", Lexile: 355, DRA: 20},
  {WCPM: 51, AREA: 7.8, Guided_Reading_Level: "L", Lexile: 365, DRA: 24},
  {WCPM: 52, AREA: 7.82, Guided_Reading_Level: "L", Lexile: 370, DRA: 24},
  {WCPM: 53, AREA: 7.84, Guided_Reading_Level: "L", Lexile: 375, DRA: 24},
  {WCPM: 54, AREA: 7.85, Guided_Reading_Level: "L", Lexile: 380, DRA: 24},
  {WCPM: 55, AREA: 7.88, Guided_Reading_Level: "L", Lexile: 385, DRA: 24},
  {WCPM: 56, AREA: 7.9, Guided_Reading_Level: "L", Lexile: 390, DRA: 24},
  {WCPM: 57, AREA: 7.93, Guided_Reading_Level: "L", Lexile: 400, DRA: 24},
  {WCPM: 58, AREA: 7.96, Guided_Reading_Level: "L", Lexile: 405, DRA: 24},
  {WCPM: 59, AREA: 7.99, Guided_Reading_Level: "L", Lexile: 415, DRA: 24},
  {WCPM: 60, AREA: 8.01, Guided_Reading_Level: "L", Lexile: 420, DRA: 24},
  {WCPM: 61, AREA: 8.03, Guided_Reading_Level: "L", Lexile: 425, DRA: 24},
  {WCPM: 62, AREA: 8.04, Guided_Reading_Level: "L", Lexile: 425, DRA: 24},
  {WCPM: 63, AREA: 8.1, Guided_Reading_Level: "M", Lexile: 440, DRA: 28},
  {WCPM: 64, AREA: 8.15, Guided_Reading_Level: "M", Lexile: 450, DRA: 28},
  {WCPM: 65, AREA: 8.2, Guided_Reading_Level: "M", Lexile: 465, DRA: 28},
  {WCPM: 66, AREA: 8.23, Guided_Reading_Level: "M", Lexile: 470, DRA: 28},
  {WCPM: 67, AREA: 8.25, Guided_Reading_Level: "M", Lexile: 475, DRA: 28},
  {WCPM: 68, AREA: 8.29, Guided_Reading_Level: "M", Lexile: 485, DRA: 28},
  {WCPM: 69, AREA: 8.33, Guided_Reading_Level: "M", Lexile: 495, DRA: 28},
  {WCPM: 70, AREA: 8.37, Guided_Reading_Level: "M", Lexile: 505, DRA: 28},
  {WCPM: 71, AREA: 8.4, Guided_Reading_Level: "N", Lexile: 510, DRA: 30},
  {WCPM: 72, AREA: 8.45, Guided_Reading_Level: "N", Lexile: 520, DRA: 30},
  {WCPM: 73, AREA: 8.49, Guided_Reading_Level: "N", Lexile: 530, DRA: 30},
  {WCPM: 74, AREA: 8.53, Guided_Reading_Level: "N", Lexile: 540, DRA: 30},
  {WCPM: 75, AREA: 8.57, Guided_Reading_Level: "N", Lexile: 550, DRA: 30},
  {WCPM: 76, AREA: 8.6, Guided_Reading_Level: "N", Lexile: 555, DRA: 30},
  {WCPM: 77, AREA: 8.64, Guided_Reading_Level: "N", Lexile: 565, DRA: 30},
  {WCPM: 78, AREA: 8.68, Guided_Reading_Level: "N", Lexile: 570, DRA: 30},
  {WCPM: 79, AREA: 8.72, Guided_Reading_Level: "N", Lexile: 580, DRA: 30},
  {WCPM: 80, AREA: 8.76, Guided_Reading_Level: "N", Lexile: 590, DRA: 30},
  {WCPM: 81, AREA: 8.8, Guided_Reading_Level: "O", Lexile: 600, DRA: 34},
  {WCPM: 82, AREA: 8.84, Guided_Reading_Level: "O", Lexile: 605, DRA: 34},
  {WCPM: 83, AREA: 8.86, Guided_Reading_Level: "O", Lexile: 610, DRA: 34},
  {WCPM: 84, AREA: 8.88, Guided_Reading_Level: "O", Lexile: 615, DRA: 34},
  {WCPM: 85, AREA: 8.9, Guided_Reading_Level: "O", Lexile: 620, DRA: 34},
  {WCPM: 86, AREA: 8.94, Guided_Reading_Level: "O", Lexile: 625, DRA: 34},
  {WCPM: 87, AREA: 8.98, Guided_Reading_Level: "O", Lexile: 635, DRA: 34},
  {WCPM: 88, AREA: 9.02, Guided_Reading_Level: "O", Lexile: 645, DRA: 34},
  {WCPM: 89, AREA: 9.06, Guided_Reading_Level: "O", Lexile: 650, DRA: 34},
  {WCPM: 90, AREA: 9.1, Guided_Reading_Level: "P", Lexile: 660, DRA: 38},
  {WCPM: 91, AREA: 9.14, Guided_Reading_Level: "P", Lexile: 665, DRA: 38},
  {WCPM: 92, AREA: 9.18, Guided_Reading_Level: "P", Lexile: 675, DRA: 38},
  {WCPM: 93, AREA: 9.22, Guided_Reading_Level: "P", Lexile: 680, DRA: 38},
  {WCPM: 94, AREA: 9.25, Guided_Reading_Level: "P", Lexile: 690, DRA: 38},
  {WCPM: 95, AREA: 9.3, Guided_Reading_Level: "P", Lexile: 695, DRA: 38},
  {WCPM: 96, AREA: 9.35, Guided_Reading_Level: "P", Lexile: 705, DRA: 38},
  {WCPM: 97, AREA: 9.4, Guided_Reading_Level: "Q", Lexile: 715, DRA: 40},
  {WCPM: 98, AREA: 9.45, Guided_Reading_Level: "Q", Lexile: 725, DRA: 40},
  {WCPM: 99, AREA: 9.5, Guided_Reading_Level: "Q", Lexile: 735, DRA: 40},
  {WCPM: 100, AREA: 9.55, Guided_Reading_Level: "Q", Lexile: 740, DRA: 40},
  {WCPM: 101, AREA: 9.6, Guided_Reading_Level: "Q", Lexile: 750, DRA: 40},
  {WCPM: 102, AREA: 9.62, Guided_Reading_Level: "Q", Lexile: 755, DRA: 40},
  {WCPM: 103, AREA: 9.64, Guided_Reading_Level: "Q", Lexile: 760, DRA: 40},
  {WCPM: 104, AREA: 9.66, Guided_Reading_Level: "Q", Lexile: 760, DRA: 40},
  {WCPM: 105, AREA: 9.68, Guided_Reading_Level: "Q", Lexile: 765, DRA: 40},
  {WCPM: 106, AREA: 9.7, Guided_Reading_Level: "R", Lexile: 770, DRA: 40},
  {WCPM: 107, AREA: 9.72, Guided_Reading_Level: "R", Lexile: 770, DRA: 40},
  {WCPM: 108, AREA: 9.74, Guided_Reading_Level: "R", Lexile: 775, DRA: 40},
  {WCPM: 109, AREA: 9.76, Guided_Reading_Level: "R", Lexile: 780, DRA: 40},
  {WCPM: 110, AREA: 9.78, Guided_Reading_Level: "R", Lexile: 780, DRA: 40},
  {WCPM: 111, AREA: 9.8, Guided_Reading_Level: "R", Lexile: 785, DRA: 40},
  {WCPM: 112, AREA: 9.83, Guided_Reading_Level: "R", Lexile: 790, DRA: 40},
  {WCPM: 113, AREA: 9.86, Guided_Reading_Level: "R", Lexile: 795, DRA: 40},
  {WCPM: 114, AREA: 9.89, Guided_Reading_Level: "R", Lexile: 800, DRA: 40},
  {WCPM: 115, AREA: 9.92, Guided_Reading_Level: "R", Lexile: 805, DRA: 40},
  {WCPM: 116, AREA: 9.95, Guided_Reading_Level: "R", Lexile: 810, DRA: 40},
  {WCPM: 117, AREA: 9.98, Guided_Reading_Level: "R", Lexile: 815, DRA: 40},
  {WCPM: 118, AREA: 10, Guided_Reading_Level: "S", Lexile: 820, DRA: 40},
  {WCPM: 119, AREA: 10.02, Guided_Reading_Level: "S", Lexile: 820, DRA: 40},
  {WCPM: 120, AREA: 10.05, Guided_Reading_Level: "S", Lexile: 825, DRA: 40},
  {WCPM: 121, AREA: 10.07, Guided_Reading_Level: "S", Lexile: 830, DRA: 40},
  {WCPM: 122, AREA: 10.1, Guided_Reading_Level: "S", Lexile: 835, DRA: 40},
  {WCPM: 123, AREA: 10.15, Guided_Reading_Level: "S", Lexile: 840, DRA: 40},
  {WCPM: 124, AREA: 10.25, Guided_Reading_Level: "S", Lexile: 855, DRA: 40},
  {WCPM: 125, AREA: 10.3, Guided_Reading_Level: "S", Lexile: 865, DRA: 40},
  {WCPM: 126, AREA: 10.4, Guided_Reading_Level: "T", Lexile: 875, DRA: 50},
  {WCPM: 127, AREA: 10.5, Guided_Reading_Level: "T", Lexile: 890, DRA: 50},
  {WCPM: 128, AREA: 10.6, Guided_Reading_Level: "T", Lexile: 905, DRA: 50},
  {WCPM: 129, AREA: 10.65, Guided_Reading_Level: "T", Lexile: 910, DRA: 50},
  {WCPM: 130, AREA: 10.7, Guided_Reading_Level: "T", Lexile: 915, DRA: 50},
  {WCPM: 131, AREA: 10.75, Guided_Reading_Level: "T", Lexile: 925, DRA: 50},
  {WCPM: 132, AREA: 10.8, Guided_Reading_Level: "U", Lexile: 930, DRA: 50},
  {WCPM: 133, AREA: 10.83, Guided_Reading_Level: "U", Lexile: 935, DRA: 50},
  {WCPM: 134, AREA: 10.86, Guided_Reading_Level: "U", Lexile: 935, DRA: 50},
  {WCPM: 135, AREA: 10.89, Guided_Reading_Level: "U", Lexile: 940, DRA: 50},
  {WCPM: 136, AREA: 10.92, Guided_Reading_Level: "U", Lexile: 945, DRA: 50},
  {WCPM: 137, AREA: 10.95, Guided_Reading_Level: "U", Lexile: 945, DRA: 50},
  {WCPM: 138, AREA: 11, Guided_Reading_Level: "U", Lexile: 955, DRA: 50},
  {WCPM: 139, AREA: 11.05, Guided_Reading_Level: "U", Lexile: 960, DRA: 50},
  {WCPM: 140, AREA: 11.1, Guided_Reading_Level: "V", Lexile: 965, DRA: 50},
  {WCPM: 141, AREA: 11.15, Guided_Reading_Level: "V", Lexile: 970, DRA: 50},
  {WCPM: 142, AREA: 11.2, Guided_Reading_Level: "V", Lexile: 975, DRA: 50},
  {WCPM: 143, AREA: 11.25, Guided_Reading_Level: "V", Lexile: 980, DRA: 50},
  {WCPM: 144, AREA: 11.3, Guided_Reading_Level: "V", Lexile: 985, DRA: 50},
  {WCPM: 145, AREA: 11.4, Guided_Reading_Level: "W", Lexile: 995, DRA: 60},
  {WCPM: 146, AREA: 11.5, Guided_Reading_Level: "W", Lexile: 1005, DRA: 60},
  {WCPM: 147, AREA: 11.6, Guided_Reading_Level: "W", Lexile: 1015, DRA: 60},
  {WCPM: 148, AREA: 11.7, Guided_Reading_Level: "W", Lexile: 1020, DRA: 60},
  {WCPM: 149, AREA: 11.75, Guided_Reading_Level: "W", Lexile: 1025, DRA: 60},
  {WCPM: 150, AREA: 11.8, Guided_Reading_Level: "X", Lexile: 1030, DRA: 60},
  {WCPM: 151, AREA: 11.9, Guided_Reading_Level: "X", Lexile: 1035, DRA: 60},
  {WCPM: 152, AREA: 11.95, Guided_Reading_Level: "X", Lexile: 1040, DRA: 60},
  {WCPM: 153, AREA: 12, Guided_Reading_Level: "X", Lexile: 1045, DRA: 60},
  {WCPM: 154, AREA: 12.1, Guided_Reading_Level: "X", Lexile: 1050, DRA: 60},
  {WCPM: 155, AREA: 12.11, Guided_Reading_Level: "X", Lexile: 1050, DRA: 60},
  {WCPM: 156, AREA: 12.12, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 157, AREA: 12.13, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 158, AREA: 12.14, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 159, AREA: 12.15, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 160, AREA: 12.16, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 161, AREA: 12.17, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 162, AREA: 12.18, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 163, AREA: 12.19, Guided_Reading_Level: "X", Lexile: 1055, DRA: 60},
  {WCPM: 164, AREA: 12.2, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 165, AREA: 12.21, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 166, AREA: 12.22, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 167, AREA: 12.23, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 168, AREA: 12.24, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 169, AREA: 12.25, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 170, AREA: 12.26, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 171, AREA: 12.27, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 172, AREA: 12.28, Guided_Reading_Level: "Y", Lexile: 1060, DRA: 60},
  {WCPM: 173, AREA: 12.29, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 174, AREA: 12.3, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 175, AREA: 12.31, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 176, AREA: 12.32, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 177, AREA: 12.33, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 178, AREA: 12.34, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 179, AREA: 12.35, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 180, AREA: 12.36, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 181, AREA: 12.37, Guided_Reading_Level: "Y", Lexile: 1065, DRA: 60},
  {WCPM: 182, AREA: 12.38, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 183, AREA: 12.39, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 184, AREA: 12.4, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 185, AREA: 12.41, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 186, AREA: 12.42, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 187, AREA: 12.43, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 188, AREA: 12.44, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 189, AREA: 12.45, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 190, AREA: 12.46, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 191, AREA: 12.47, Guided_Reading_Level: "Y", Lexile: 1070, DRA: 60},
  {WCPM: 192, AREA: 12.48, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 193, AREA: 12.49, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 194, AREA: 12.5, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 195, AREA: 12.51, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 196, AREA: 12.52, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 197, AREA: 12.53, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 198, AREA: 12.54, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 199, AREA: 12.55, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 200, AREA: 12.56, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 201, AREA: 12.57, Guided_Reading_Level: "Y", Lexile: 1075, DRA: 60},
  {WCPM: 202, AREA: 12.58, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 203, AREA: 12.59, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 204, AREA: 12.6, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 205, AREA: 12.61, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 206, AREA: 12.62, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 207, AREA: 12.63, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 208, AREA: 12.64, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 209, AREA: 12.65, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 210, AREA: 12.66, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 211, AREA: 12.67, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 212, AREA: 12.68, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 213, AREA: 12.69, Guided_Reading_Level: "Y", Lexile: 1080, DRA: 60},
  {WCPM: 214, AREA: 12.7, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 215, AREA: 12.71, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 216, AREA: 12.72, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 217, AREA: 12.73, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 218, AREA: 12.74, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 219, AREA: 12.75, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 220, AREA: 12.76, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 221, AREA: 12.77, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 222, AREA: 12.78, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 223, AREA: 12.79, Guided_Reading_Level: "Y", Lexile: 1085, DRA: 60},
  {WCPM: 224, AREA: 12.8, Guided_Reading_Level: "Z", Lexile: 1085, DRA: 70},
  {WCPM: 225, AREA: 12.81, Guided_Reading_Level: "Z", Lexile: 1085, DRA: 70},
  {WCPM: 226, AREA: 12.82, Guided_Reading_Level: "Z", Lexile: 1085, DRA: 70},
  {WCPM: 227, AREA: 12.83, Guided_Reading_Level: "Z", Lexile: 1085, DRA: 70},
  {WCPM: 228, AREA: 12.84, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 229, AREA: 12.85, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 230, AREA: 12.86, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 231, AREA: 12.87, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 232, AREA: 12.88, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 233, AREA: 12.89, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 234, AREA: 12.9, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 235, AREA: 12.91, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 236, AREA: 12.92, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 237, AREA: 12.93, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 238, AREA: 12.94, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 239, AREA: 12.95, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 240, AREA: 12.96, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 241, AREA: 12.97, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 242, AREA: 12.98, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 243, AREA: 12.99, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 244, AREA: 13, Guided_Reading_Level: "Z", Lexile: 1090, DRA: 70},
  {WCPM: 245, AREA: 13.01, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 246, AREA: 13.02, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 247, AREA: 13.03, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 248, AREA: 13.04, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 249, AREA: 13.05, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 250, AREA: 13.06, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 251, AREA: 13.07, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 252, AREA: 13.08, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 253, AREA: 13.09, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 70},
  {WCPM: 254, AREA: 13.1, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 255, AREA: 13.11, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 256, AREA: 13.12, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 257, AREA: 13.13, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 258, AREA: 13.14, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 259, AREA: 13.15, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 260, AREA: 13.16, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 261, AREA: 13.17, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 262, AREA: 13.18, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 263, AREA: 13.19, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 264, AREA: 13.2, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 265, AREA: 13.21, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 266, AREA: 13.22, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 267, AREA: 13.23, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 268, AREA: 13.24, Guided_Reading_Level: "Z", Lexile: 1095, DRA: 80},
  {WCPM: 269, AREA: 13.25, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 270, AREA: 13.26, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 271, AREA: 13.27, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 272, AREA: 13.28, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 273, AREA: 13.29, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 274, AREA: 13.3, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 275, AREA: 13.31, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 276, AREA: 13.32, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 277, AREA: 13.33, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 278, AREA: 13.34, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 279, AREA: 13.35, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 280, AREA: 13.36, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 281, AREA: 13.37, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 282, AREA: 13.38, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 283, AREA: 13.39, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 284, AREA: 13.4, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 285, AREA: 13.41, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 286, AREA: 13.42, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 287, AREA: 13.43, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 288, AREA: 13.44, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 289, AREA: 13.45, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 290, AREA: 13.46, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 291, AREA: 13.47, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 292, AREA: 13.48, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 293, AREA: 13.49, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 294, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 295, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 296, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 297, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 298, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 299, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80},
  {WCPM: 300, AREA: 13.5, Guided_Reading_Level: "Z", Lexile: 1100, DRA: 80}
];

const spanishAreaConcordance = [
	{WCPM: 0, AREA: 3.78,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 1, AREA: 4.53,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 2, AREA: 4.83,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 3, AREA: 5.06,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 4, AREA: 5.25,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 5, AREA: 5.41,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 6, AREA: 5.56,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 7, AREA: 5.7,  Guided_Reading_Level:  "A",  Lexile: -400,  DRA:  1},
  {WCPM: 8, AREA: 5.82,  Guided_Reading_Level:  "B",  Lexile: -365,  DRA:  2},
  {WCPM: 9, AREA: 5.94,  Guided_Reading_Level:  "B",  Lexile: -350,  DRA:  2},
  {WCPM: 10, AREA: 6.05,  Guided_Reading_Level:  "B",  Lexile: -325,  DRA:  2},
  {WCPM: 11, AREA: 6.15,  Guided_Reading_Level:  "B",  Lexile: -300,  DRA:  2},
  {WCPM: 12, AREA: 6.25,  Guided_Reading_Level:  "B",  Lexile: -280,  DRA:  2},
  {WCPM: 13, AREA: 6.34,  Guided_Reading_Level:  "B",  Lexile: -255,  DRA:  2},
  {WCPM: 14, AREA: 6.43,  Guided_Reading_Level:  "C",  Lexile: -225,  DRA:  3},
  {WCPM: 15, AREA: 6.52,  Guided_Reading_Level:  "C",  Lexile: -185,  DRA:  3},
  {WCPM: 16, AREA: 6.6,  Guided_Reading_Level:  "C",  Lexile: -165,  DRA:  3},
  {WCPM: 17, AREA: 6.68,  Guided_Reading_Level:  "C",  Lexile: -145,  DRA:  3},
  {WCPM: 18, AREA: 6.75,  Guided_Reading_Level:  "D",  Lexile: -130,  DRA:  4},
  {WCPM: 19, AREA: 6.83,  Guided_Reading_Level:  "D",  Lexile: -110,  DRA:  4},
  {WCPM: 20, AREA: 6.9,  Guided_Reading_Level:  "D",  Lexile: -80,  DRA:  4},
  {WCPM: 21, AREA: 6.97,  Guided_Reading_Level:  "D",  Lexile: -60,  DRA:  4},
  {WCPM: 22, AREA: 7.04,  Guided_Reading_Level:  "E",  Lexile: -30,  DRA:  6},
  {WCPM: 23, AREA: 7.1,  Guided_Reading_Level:  "E",  Lexile: -15,  DRA:  6},
  {WCPM: 24, AREA: 7.17,  Guided_Reading_Level:  "E",  Lexile: 0,  DRA:  8},
  {WCPM: 25, AREA: 7.23,  Guided_Reading_Level:  "E",  Lexile: 15,  DRA:  8},
  {WCPM: 26, AREA: 7.29,  Guided_Reading_Level:  "F",  Lexile: 30,  DRA:  10},
  {WCPM: 27, AREA: 7.35,  Guided_Reading_Level:  "F",  Lexile: 80,  DRA:  10},
  {WCPM: 28, AREA: 7.41,  Guided_Reading_Level:  "F",  Lexile: 90,  DRA:  10},
  {WCPM: 29, AREA: 7.46,  Guided_Reading_Level:  "G ",  Lexile: 95,  DRA:  12},
  {WCPM: 30, AREA: 7.52,  Guided_Reading_Level:  "G ",  Lexile: 100,  DRA:  12},
  {WCPM: 31, AREA: 7.57,  Guided_Reading_Level:  "G ",  Lexile: 120,  DRA:  12},
  {WCPM: 32, AREA: 7.63,  Guided_Reading_Level:  "H",  Lexile: 135,  DRA:  14},
  {WCPM: 33, AREA: 7.68,  Guided_Reading_Level:  "H",  Lexile: 150,  DRA:  14},
  {WCPM: 34, AREA: 7.73,  Guided_Reading_Level:  "H",  Lexile: 165,  DRA:  14},
  {WCPM: 35, AREA: 7.78,  Guided_Reading_Level:  "I",  Lexile: 180,  DRA:  16},
  {WCPM: 36, AREA: 7.83,  Guided_Reading_Level:  "I",  Lexile: 195,  DRA:  16},
  {WCPM: 37, AREA: 7.88,  Guided_Reading_Level:  "I",  Lexile: 205,  DRA:  16},
  {WCPM: 38, AREA: 7.92,  Guided_Reading_Level:  "J",  Lexile: 220,  DRA:  18},
  {WCPM: 39, AREA: 7.97,  Guided_Reading_Level:  "J",  Lexile: 235,  DRA:  18},
  {WCPM: 40, AREA: 8.02,  Guided_Reading_Level:  "J",  Lexile: 245,  DRA:  18},
  {WCPM: 41, AREA: 8.06,  Guided_Reading_Level:  "K",  Lexile: 260,  DRA:  20},
  {WCPM: 42, AREA: 8.11,  Guided_Reading_Level:  "K",  Lexile: 275,  DRA:  20},
  {WCPM: 43, AREA: 8.15,  Guided_Reading_Level:  "K",  Lexile: 280,  DRA:  20},
  {WCPM: 44, AREA: 8.19,  Guided_Reading_Level:  "K",  Lexile: 290,  DRA:  20},
  {WCPM: 45, AREA: 8.24,  Guided_Reading_Level:  "K",  Lexile: 305,  DRA:  20},
  {WCPM: 46, AREA: 8.28,  Guided_Reading_Level:  "K",  Lexile: 305,  DRA:  20},
  {WCPM: 47, AREA: 8.32,  Guided_Reading_Level:  "K",  Lexile: 310,  DRA:  20},
  {WCPM: 48, AREA: 8.36,  Guided_Reading_Level:  "K",  Lexile: 315,  DRA:  20},
  {WCPM: 49, AREA: 8.4,  Guided_Reading_Level:  "K",  Lexile: 340,  DRA:  20},
  {WCPM: 50, AREA: 8.44,  Guided_Reading_Level:  "K",  Lexile: 355,  DRA:  20},
  {WCPM: 51, AREA: 8.48,  Guided_Reading_Level:  "L",  Lexile: 365,  DRA:  24},
  {WCPM: 52, AREA: 8.52,  Guided_Reading_Level:  "L",  Lexile: 370,  DRA:  24},
  {WCPM: 53, AREA: 8.55,  Guided_Reading_Level:  "L",  Lexile: 375,  DRA:  24},
  {WCPM: 54, AREA: 8.59,  Guided_Reading_Level:  "L",  Lexile: 380,  DRA:  24},
  {WCPM: 55, AREA: 8.63,  Guided_Reading_Level:  "L",  Lexile: 385,  DRA:  24},
  {WCPM: 56, AREA: 8.66,  Guided_Reading_Level:  "L",  Lexile: 390,  DRA:  24},
  {WCPM: 57, AREA: 8.7,  Guided_Reading_Level:  "L",  Lexile: 400,  DRA:  24},
  {WCPM: 58, AREA: 8.73,  Guided_Reading_Level:  "L",  Lexile: 405,  DRA:  24},
  {WCPM: 59, AREA: 8.77,  Guided_Reading_Level:  "L",  Lexile: 415,  DRA:  24},
  {WCPM: 60, AREA: 8.8,  Guided_Reading_Level:  "L",  Lexile: 420,  DRA:  24},
  {WCPM: 61, AREA: 8.84,  Guided_Reading_Level:  "L",  Lexile: 425,  DRA:  24},
  {WCPM: 62, AREA: 8.87,  Guided_Reading_Level:  "L",  Lexile: 425,  DRA:  24},
  {WCPM: 63, AREA: 8.91,  Guided_Reading_Level:  "M",  Lexile: 440,  DRA:  28},
  {WCPM: 64, AREA: 8.94,  Guided_Reading_Level:  "M",  Lexile: 450,  DRA:  28},
  {WCPM: 65, AREA: 8.97,  Guided_Reading_Level:  "M",  Lexile: 465,  DRA:  28},
  {WCPM: 66, AREA: 9,  Guided_Reading_Level:  "M",  Lexile: 470,  DRA:  28},
  {WCPM: 67, AREA: 9.04,  Guided_Reading_Level:  "M",  Lexile: 475,  DRA:  28},
  {WCPM: 68, AREA: 9.07,  Guided_Reading_Level:  "M",  Lexile: 485,  DRA:  28},
  {WCPM: 69, AREA: 9.1,  Guided_Reading_Level:  "M",  Lexile: 495,  DRA:  28},
  {WCPM: 70, AREA: 9.13,  Guided_Reading_Level:  "M",  Lexile: 505,  DRA:  28},
  {WCPM: 71, AREA: 9.16,  Guided_Reading_Level:  "N",  Lexile: 510,  DRA:  30},
  {WCPM: 72, AREA: 9.19,  Guided_Reading_Level:  "N",  Lexile: 520,  DRA:  30},
  {WCPM: 73, AREA: 9.22,  Guided_Reading_Level:  "N",  Lexile: 530,  DRA:  30},
  {WCPM: 74, AREA: 9.25,  Guided_Reading_Level:  "N",  Lexile: 540,  DRA:  30},
  {WCPM: 75, AREA: 9.28,  Guided_Reading_Level:  "N",  Lexile: 550,  DRA:  30},
  {WCPM: 76, AREA: 9.31,  Guided_Reading_Level:  "N",  Lexile: 555,  DRA:  30},
  {WCPM: 77, AREA: 9.34,  Guided_Reading_Level:  "N",  Lexile: 565,  DRA:  30},
  {WCPM: 78, AREA: 9.37,  Guided_Reading_Level:  "N",  Lexile: 570,  DRA:  30},
  {WCPM: 79, AREA: 9.39,  Guided_Reading_Level:  "N",  Lexile: 580,  DRA:  30},
  {WCPM: 80, AREA: 9.42,  Guided_Reading_Level:  "N",  Lexile: 590,  DRA:  30},
  {WCPM: 81, AREA: 9.45,  Guided_Reading_Level:  "O",  Lexile: 600,  DRA:  34},
  {WCPM: 82, AREA: 9.48,  Guided_Reading_Level:  "O",  Lexile: 605,  DRA:  34},
  {WCPM: 83, AREA: 9.5,  Guided_Reading_Level:  "O",  Lexile: 610,  DRA:  34},
  {WCPM: 84, AREA: 9.53,  Guided_Reading_Level:  "O",  Lexile: 615,  DRA:  34},
  {WCPM: 85, AREA: 9.56,  Guided_Reading_Level:  "O",  Lexile: 620,  DRA:  34},
  {WCPM: 86, AREA: 9.58,  Guided_Reading_Level:  "O",  Lexile: 625,  DRA:  34},
  {WCPM: 87, AREA: 9.61,  Guided_Reading_Level:  "O",  Lexile: 635,  DRA:  34},
  {WCPM: 88, AREA: 9.64,  Guided_Reading_Level:  "O",  Lexile: 645,  DRA:  34},
  {WCPM: 89, AREA: 9.66,  Guided_Reading_Level:  "O",  Lexile: 650,  DRA:  34},
  {WCPM: 90, AREA: 9.69,  Guided_Reading_Level:  "P",  Lexile: 660,  DRA:  38},
  {WCPM: 91, AREA: 9.71,  Guided_Reading_Level:  "P",  Lexile: 665,  DRA:  38},
  {WCPM: 92, AREA: 9.74,  Guided_Reading_Level:  "P",  Lexile: 675,  DRA:  38},
  {WCPM: 93, AREA: 9.76,  Guided_Reading_Level:  "P",  Lexile: 680,  DRA:  38},
  {WCPM: 94, AREA: 9.79,  Guided_Reading_Level:  "P",  Lexile: 690,  DRA:  38},
  {WCPM: 95, AREA: 9.81,  Guided_Reading_Level:  "P",  Lexile: 695,  DRA:  38},
  {WCPM: 96, AREA: 9.83,  Guided_Reading_Level:  "P",  Lexile: 705,  DRA:  38},
  {WCPM: 97, AREA: 9.86,  Guided_Reading_Level:  "Q",  Lexile: 715,  DRA:  40},
  {WCPM: 98, AREA: 9.88,  Guided_Reading_Level:  "Q",  Lexile: 725,  DRA:  40},
  {WCPM: 99, AREA: 9.91,  Guided_Reading_Level:  "Q",  Lexile: 735,  DRA:  40},
  {WCPM: 100, AREA: 9.93,  Guided_Reading_Level:  "Q",  Lexile: 740,  DRA:  40},
  {WCPM: 101, AREA: 9.95,  Guided_Reading_Level:  "Q",  Lexile: 750,  DRA:  40},
  {WCPM: 102, AREA: 9.98,  Guided_Reading_Level:  "Q",  Lexile: 755,  DRA:  40},
  {WCPM: 103, AREA: 10,  Guided_Reading_Level:  "Q",  Lexile: 760,  DRA:  40},
  {WCPM: 104, AREA: 10.02,  Guided_Reading_Level:  "Q",  Lexile: 760,  DRA:  40},
  {WCPM: 105, AREA: 10.04,  Guided_Reading_Level:  "Q",  Lexile: 765,  DRA:  40},
  {WCPM: 106, AREA: 10.07,  Guided_Reading_Level:  "R",  Lexile: 770,  DRA:  40},
  {WCPM: 107, AREA: 10.09,  Guided_Reading_Level:  "R",  Lexile: 770,  DRA:  40},
  {WCPM: 108, AREA: 10.11,  Guided_Reading_Level:  "R",  Lexile: 775,  DRA:  40},
  {WCPM: 109, AREA: 10.13,  Guided_Reading_Level:  "R",  Lexile: 780,  DRA:  40},
  {WCPM: 110, AREA: 10.15,  Guided_Reading_Level:  "R",  Lexile: 780,  DRA:  40},
  {WCPM: 111, AREA: 10.17,  Guided_Reading_Level:  "R",  Lexile: 785,  DRA:  40},
  {WCPM: 112, AREA: 10.2,  Guided_Reading_Level:  "R",  Lexile: 790,  DRA:  40},
  {WCPM: 113, AREA: 10.22,  Guided_Reading_Level:  "R",  Lexile: 795,  DRA:  40},
  {WCPM: 114, AREA: 10.24,  Guided_Reading_Level:  "R",  Lexile: 800,  DRA:  40},
  {WCPM: 115, AREA: 10.26,  Guided_Reading_Level:  "R",  Lexile: 805,  DRA:  40},
  {WCPM: 116, AREA: 10.28,  Guided_Reading_Level:  "R",  Lexile: 810,  DRA:  40},
  {WCPM: 117, AREA: 10.3,  Guided_Reading_Level:  "R",  Lexile: 815,  DRA:  40},
  {WCPM: 118, AREA: 10.32,  Guided_Reading_Level:  "S",  Lexile: 820,  DRA:  40},
  {WCPM: 119, AREA: 10.34,  Guided_Reading_Level:  "S",  Lexile: 820,  DRA:  40},
  {WCPM: 120, AREA: 10.36,  Guided_Reading_Level:  "S",  Lexile: 825,  DRA:  40},
  {WCPM: 121, AREA: 10.38,  Guided_Reading_Level:  "S",  Lexile: 830,  DRA:  40},
  {WCPM: 122, AREA: 10.4,  Guided_Reading_Level:  "S",  Lexile: 835,  DRA:  40},
  {WCPM: 123, AREA: 10.42,  Guided_Reading_Level:  "S",  Lexile: 840,  DRA:  40},
  {WCPM: 124, AREA: 10.44,  Guided_Reading_Level:  "S",  Lexile: 855,  DRA:  40},
  {WCPM: 125, AREA: 10.46,  Guided_Reading_Level:  "S",  Lexile: 865,  DRA:  40},
  {WCPM: 126, AREA: 10.48,  Guided_Reading_Level:  "T",  Lexile: 875,  DRA:  50},
  {WCPM: 127, AREA: 10.5,  Guided_Reading_Level:  "T",  Lexile: 890,  DRA:  50},
  {WCPM: 128, AREA: 10.51,  Guided_Reading_Level:  "T",  Lexile: 905,  DRA:  50},
  {WCPM: 129, AREA: 10.53,  Guided_Reading_Level:  "T",  Lexile: 910,  DRA:  50},
  {WCPM: 130, AREA: 10.55,  Guided_Reading_Level:  "T",  Lexile: 915,  DRA:  50},
  {WCPM: 131, AREA: 10.57,  Guided_Reading_Level:  "T",  Lexile: 925,  DRA:  50},
  {WCPM: 132, AREA: 10.59,  Guided_Reading_Level:  "U",  Lexile: 930,  DRA:  50},
  {WCPM: 133, AREA: 10.61,  Guided_Reading_Level:  "U",  Lexile: 935,  DRA:  50},
  {WCPM: 134, AREA: 10.63,  Guided_Reading_Level:  "U",  Lexile: 935,  DRA:  50},
  {WCPM: 135, AREA: 10.64,  Guided_Reading_Level:  "U",  Lexile: 940,  DRA:  50},
  {WCPM: 136, AREA: 10.66,  Guided_Reading_Level:  "U",  Lexile: 945,  DRA:  50},
  {WCPM: 137, AREA: 10.68,  Guided_Reading_Level:  "U",  Lexile: 945,  DRA:  50},
  {WCPM: 138, AREA: 10.7,  Guided_Reading_Level:  "U",  Lexile: 955,  DRA:  50},
  {WCPM: 139, AREA: 10.71,  Guided_Reading_Level:  "U",  Lexile: 960,  DRA:  50},
  {WCPM: 140, AREA: 10.73,  Guided_Reading_Level:  "V",  Lexile: 965,  DRA:  50},
  {WCPM: 141, AREA: 10.75,  Guided_Reading_Level:  "V",  Lexile: 970,  DRA:  50},
  {WCPM: 142, AREA: 10.77,  Guided_Reading_Level:  "V",  Lexile: 975,  DRA:  50},
  {WCPM: 143, AREA: 10.78,  Guided_Reading_Level:  "V",  Lexile: 980,  DRA:  50},
  {WCPM: 144, AREA: 10.8,  Guided_Reading_Level:  "V",  Lexile: 985,  DRA:  50},
  {WCPM: 145, AREA: 10.82,  Guided_Reading_Level:  "W",  Lexile: 995,  DRA:  60},
  {WCPM: 146, AREA: 10.83,  Guided_Reading_Level:  "W",  Lexile: 1005,  DRA:  60},
  {WCPM: 147, AREA: 10.85,  Guided_Reading_Level:  "W",  Lexile: 1015,  DRA:  60},
  {WCPM: 148, AREA: 10.87,  Guided_Reading_Level:  "W",  Lexile: 1020,  DRA:  60},
  {WCPM: 149, AREA: 10.88,  Guided_Reading_Level:  "W",  Lexile: 1025,  DRA:  60},
  {WCPM: 150, AREA: 10.9,  Guided_Reading_Level:  "X",  Lexile: 1030,  DRA:  60},
  {WCPM: 151, AREA: 10.92,  Guided_Reading_Level:  "X",  Lexile: 1035,  DRA:  60},
  {WCPM: 152, AREA: 10.93,  Guided_Reading_Level:  "X",  Lexile: 1040,  DRA:  60},
  {WCPM: 153, AREA: 10.95,  Guided_Reading_Level:  "X",  Lexile: 1045,  DRA:  60},
  {WCPM: 154, AREA: 10.96,  Guided_Reading_Level:  "X",  Lexile: 1050,  DRA:  60},
  {WCPM: 155, AREA: 10.98,  Guided_Reading_Level:  "X",  Lexile: 1050,  DRA:  60},
  {WCPM: 156, AREA: 10.99,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 157, AREA: 11.01,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 158, AREA: 11.03,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 159, AREA: 11.04,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 160, AREA: 11.06,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 161, AREA: 11.07,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 162, AREA: 11.09,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 163, AREA: 11.1,  Guided_Reading_Level:  "X",  Lexile: 1055,  DRA:  60},
  {WCPM: 164, AREA: 11.12,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 165, AREA: 11.13,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 166, AREA: 11.15,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 167, AREA: 11.16,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 168, AREA: 11.18,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 169, AREA: 11.19,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 170, AREA: 11.2,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 171, AREA: 11.22,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 172, AREA: 11.23,  Guided_Reading_Level:  "Y",  Lexile: 1060,  DRA:  60},
  {WCPM: 173, AREA: 11.25,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 174, AREA: 11.26,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 175, AREA: 11.27,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 176, AREA: 11.29,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 177, AREA: 11.3,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 178, AREA: 11.32,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 179, AREA: 11.33,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 180, AREA: 11.34,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 181, AREA: 11.36,  Guided_Reading_Level:  "Y",  Lexile: 1065,  DRA:  60},
  {WCPM: 182, AREA: 11.37,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 183, AREA: 11.38,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 184, AREA: 11.4,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 185, AREA: 11.41,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 186, AREA: 11.42,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 187, AREA: 11.44,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 188, AREA: 11.45,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 189, AREA: 11.46,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 190, AREA: 11.47,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 191, AREA: 11.49,  Guided_Reading_Level:  "Y",  Lexile: 1070,  DRA:  60},
  {WCPM: 192, AREA: 11.5,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 193, AREA: 11.51,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 194, AREA: 11.52,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 195, AREA: 11.54,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 196, AREA: 11.55,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 197, AREA: 11.56,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 198, AREA: 11.57,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 199, AREA: 11.59,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 200, AREA: 11.6,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 201, AREA: 11.61,  Guided_Reading_Level:  "Y",  Lexile: 1075,  DRA:  60},
  {WCPM: 202, AREA: 11.62,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 203, AREA: 11.63,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 204, AREA: 11.65,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 205, AREA: 11.66,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 206, AREA: 11.67,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 207, AREA: 11.68,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 208, AREA: 11.69,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 209, AREA: 11.7,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 210, AREA: 11.72,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 211, AREA: 11.73,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 212, AREA: 11.74,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 213, AREA: 11.75,  Guided_Reading_Level:  "Y",  Lexile: 1080,  DRA:  60},
  {WCPM: 214, AREA: 11.76,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 215, AREA: 11.77,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 216, AREA: 11.78,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 217, AREA: 11.79,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 218, AREA: 11.8,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 219, AREA: 11.82,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 220, AREA: 11.83,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 221, AREA: 11.84,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 222, AREA: 11.85,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 223, AREA: 11.86,  Guided_Reading_Level:  "Y",  Lexile: 1085,  DRA:  60},
  {WCPM: 224, AREA: 11.87,  Guided_Reading_Level:  "Z",  Lexile: 1085,  DRA:  70},
  {WCPM: 225, AREA: 11.88,  Guided_Reading_Level:  "Z",  Lexile: 1085,  DRA:  70},
  {WCPM: 226, AREA: 11.89,  Guided_Reading_Level:  "Z",  Lexile: 1085,  DRA:  70},
  {WCPM: 227, AREA: 11.9,  Guided_Reading_Level:  "Z",  Lexile: 1085,  DRA:  70},
  {WCPM: 228, AREA: 11.91,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 229, AREA: 11.92,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 230, AREA: 11.93,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 231, AREA: 11.94,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 232, AREA: 11.95,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 233, AREA: 11.96,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 234, AREA: 11.97,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 235, AREA: 11.98,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 236, AREA: 11.99,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 237, AREA: 12,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 238, AREA: 12.01,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 239, AREA: 12.02,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 240, AREA: 12.03,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 241, AREA: 12.04,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 242, AREA: 12.05,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 243, AREA: 12.06,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 244, AREA: 12.07,  Guided_Reading_Level:  "Z",  Lexile: 1090,  DRA:  70},
  {WCPM: 245, AREA: 12.08,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 246, AREA: 12.09,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 247, AREA: 12.1,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 248, AREA: 12.11,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 249, AREA: 12.12,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 250, AREA: 12.13,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 251, AREA: 12.13,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 252, AREA: 12.14,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 253, AREA: 12.15,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  70},
  {WCPM: 254, AREA: 12.16,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 255, AREA: 12.17,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 256, AREA: 12.18,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 257, AREA: 12.19,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 258, AREA: 12.2,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 259, AREA: 12.21,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 260, AREA: 12.21,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 261, AREA: 12.22,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 262, AREA: 12.23,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 263, AREA: 12.24,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 264, AREA: 12.25,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 265, AREA: 12.26,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 266, AREA: 12.27,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 267, AREA: 12.27,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 268, AREA: 12.28,  Guided_Reading_Level:  "Z",  Lexile: 1095,  DRA:  80},
  {WCPM: 269, AREA: 12.29,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 270, AREA: 12.3,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 271, AREA: 12.31,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 272, AREA: 12.32,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 273, AREA: 12.32,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 274, AREA: 12.33,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 275, AREA: 12.34,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 276, AREA: 12.35,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 277, AREA: 12.36,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 278, AREA: 12.36,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 279, AREA: 12.37,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 280, AREA: 12.38,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 281, AREA: 12.39,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 282, AREA: 12.4,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 283, AREA: 12.4,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 284, AREA: 12.41,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 285, AREA: 12.42,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 286, AREA: 12.43,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 287, AREA: 12.43,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 288, AREA: 12.44,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 289, AREA: 12.45,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 290, AREA: 12.46,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 291, AREA: 12.46,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 292, AREA: 12.47,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 293, AREA: 12.48,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 294, AREA: 12.49,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 295, AREA: 12.49,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 296, AREA: 12.5,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 297, AREA: 12.51,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 298, AREA: 12.52,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 299, AREA: 12.52,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80},
  {WCPM: 300, AREA: 12.53,  Guided_Reading_Level:  "Z",  Lexile: 1100,  DRA:  80}
];

export default {
  scaleScore,
  scaleORF,
  scaleType,
  calculateBaseScore,
  wcpmToArea,
  calculateCLS,
  doConcordance
}